<template>
  <div>
    <MainHeader />

    <!-- Second block -->
    <div class="uk-margin-large-left uk-margin-large-right">
      <div class="uk-flex-around">
        <h2 class="uk-margin-medium-top">
          Beluister mijn stem
        </h2>
      </div>
      <div class="
        uk-child-width-1-3@s
        uk-grid-match-height
        uk-grid-column-small
        uk-grid-row-small
        " uk-grid
      >
        <VoiceDemoCard
          price="Voice over v.a. € 29,-"
          title="Allround stemdemo"
          :audio-file="require('@/assets/audio/Jason_de_ridder_compilatie.mp3')"
          audio-name="vdc-001"
          class="uk-margin-auto"
        />
<!--        <VoiceDemoCard-->
<!--          price="€ 99,-"-->
<!--          title="Bedrijfsfilm stemdemo"-->
<!--          audio-file="/assets/audio/Autoritair.m4a"-->
<!--          audio-name="demo-autoritair"-->
<!--        />-->
<!--        <VoiceDemoCard-->
<!--          price="€ 500,-"-->
<!--          title="Commercial stemdemo"-->
<!--          audio-file="commercial.mp3"-->
<!--          audio-name="vdc-003"-->
<!--        />-->
      </div>

      <div class="uk-flex uk-flex-around uk-margin-large-top@m">
        <router-link to="/voice-over-aanvragen" class="
          uk-button
          uk-button-default
          uk-button-large
          uk-margin-large-top@m
          uk-margin-medium-top
          "
        >
          <u>GRATIS</u> stemdemo aanvragen
        </router-link>
      </div>
    </div>
    <!-- End of second block -->

    <!-- Third block -->
    <section class="uk-section uk-container uk-margin-large-top uk-padding-remove-bottom">
      <hr class="uk-hr"/>
      <USPCardContainer/>
    </section>
    <!-- End of third block -->

    <!-- Fourth block -->
    <section class="uk-section uk-container-expand uk-margin-remove-top uk-padding-remove-top">
      <div class="uk-grid uk-grid-collapse">

        <div class="uk-cover-container uk-hidden@m">
          <canvas width="800" height="350"></canvas>
          <img
            :src="require('@/assets/images/uitleg-stemdemo@small.png')"
            alt="Stemdemo"
            class=""
            uk-cover
          />
        </div>
        <image-section-text
          sub-title="Voice over aanvragen"
          title="Demo&rsquo;s zijn leuk, vooral als het niks kost."
          button-text="Gratis stemdemo"
          button-link="/voice-over-aanvragen"
        >
          Algemene demo’s zijn leuk en geven een goed beeld van mijn stem,
          maar het is natuurlijk anders dan de tekst die jij wilt laten inspreken.
          Daarom maak ik graag gratis en vrijblijvend een demo voor je.
          Mocht je daarna kiezen om mij in te huren voor jouw inspreekklus (#ZinIn)
          hebben we direct een beginpunt om verder te werken om zo snel mogelijk
          de juiste tone of voice te vinden!
        </image-section-text>
        <div class="uk-width-1-2@m uk-cover-container uk-visible@m">
          <img
            :src="require('@/assets/images/uitleg-stemdemo.png')"
            alt="Stemdemo"
            class=""
          />
        </div>

        <div class="uk-width-1-2@m uk-visible@m">
          <img :src="require('@/assets/images/tevredenheidsgarantie.jpg')"
               alt="100% tevreden"
          />
        </div>
        <div class="uk-cover-container uk-hidden@m">
          <canvas width="800" height="300"></canvas>
          <img
            :src="require('@/assets/images/tevredenheidsgarantie@small.jpg')"
            alt="Stemdemo"
            class=""
            uk-cover
          />
        </div>
        <image-section-text
          sub-title="De juiste toon zetten"
          title="Zeker weten dat jij tevreden bent."
          button-text="Ook tevreden worden?"
          :primary="true"
          button-link="/tevredenheid"
        >
          Jouw tekst moet een gevoel overbrengen, en een gevoel is niet altijd meteen
          in woorden te vatten. Het kan daarom een hele klus zijn om de emotie die jij
          zoekt mij uit te laten dragen. Gelukkig heb ik veel ervaring om met
          verschillende regisseurs en opdrachtgevers te werken en kan ik vaak snel de
          juiste toon vinden. Mocht het onverhoopt toch niet zijn wat je bedoelde, dan
          doe ik het gewoon over. Net zolang totdat jij tevreden bent!
        </image-section-text>

        <div class="uk-cover-container uk-hidden@m">
          <canvas width="800" height="300"></canvas>
          <img
            :src="require('@/assets/images/indethuisstudio@small.jpg')"
            alt="Stemdemo"
            class=""
            uk-cover
          />
        </div>
        <image-section-text
          sub-title="Aan de knoppen"
          title="In de thuisstudio"
          button-text="Vraag een gratis sample aan"
          button-link="/voice-over-aanvragen"
        >
          Doordat ik beschik over een thuisstudio is het niet noodzakelijk een studio te huren.
          In principe spreken we de opdracht door en lever ik je daarna het schoongesneden bestand
          aan. Dat betekent dat ik alle versprekingen, klikjes en andere vreemde geluidjes uit de
          opname haal. Ik neem op door middel van een Røde NT-1A via een Focusrite 3rd gen. Ik
          lever de bestanden aan in WAV-formaat (of een ander formaat indien gewenst).<br>
          Veel voice-overs kan ik binnen 24 uur leveren. Ook in het weekend. Mocht je het nog
          sneller nodig hebben kun je het beste contact opnemen.
        </image-section-text>
        <div class="uk-width-1-2@m uk-cover-container uk-visible@m">
          <img
            :src="require('@/assets/images/indethuisstudio.jpg')"
            alt="Test - Test - 1, 2, 3. Staat dit ding wel aan?"
            class=""
          />
        </div>

        <div class="uk-cover-container uk-hidden@m">
          <canvas width="800" height="300"></canvas>
          <img
            :src="require('@/assets/images/interactivevoiceresponse@small.jpg')"
            alt="Stemdemo"
            class=""
            uk-cover
          />
        </div>
        <div class="uk-width-1-2@m uk-visible@m">
          <img :src="require('@/assets/images/interactivevoiceresponse.jpg')"
               alt="Bliep - dit is een voice response"
          />
        </div>
        <image-section-text
          sub-title="Toets 1 voor..."
          title="Interactive Voice Response (IVR), voicemail of meldteksten."
          button-text="Wil je een voorbeeld? Bel naar ..."
          :primary="true"
        >
          Als klanten jouw bedrijf bellen wil je hen natuurlijk direct te woord staan.
          Dat kan helaas niet altijd, maar een Voice Response of &lsquo;telefoonbandje&rsquo;
          kan je daarbij helpen. Omdat er direct opgenomen wordt zullen je klanten zich direct
          welkom voelen. Tegelijkertijd kun je je klanten meerdere keuzes voorschotelen
          om ze direct met de juiste afdeling of medewerker te verbinden.
        </image-section-text>

        <div class="uk-cover-container uk-hidden@m">
          <canvas width="800" height="300"></canvas>
          <img
            :src="require('@/assets/images/watkostdat@small.png')"
            alt="Stemdemo"
            class=""
            uk-cover
          />
        </div>
        <image-section-text
          sub-title="¿Cuánto cuesta?"
          title="Wat een voice over kost."
          button-text="Bereken wat jouw project kost"
          button-link="/tarieven"
        >
          De tarieven van een stemacteur kunnen erg verschillen en hebben vaak te maken
          met het aantal woorden, of het totaal aantal minuten of uren. Maar er zit
          ook een verschil in het medium en of de voice-over gebruikt wordt voor
          commerciële doeleinden of niet. Om een goede indicatie te krijgen van de
          kosten kun je het beste het formulier invullen. Dat kan ook zonder dat
          je je gegevens hoeft in te vullen!<br>
          <br>
          Trouwens: aan sommige goede doelen geef ik graag een korting, doe een
          aanvraag en selecteer &lsquo;Ik doe de aanvraag namens een goed doel&rsquo;.
        </image-section-text>
        <div class="uk-width-1-2@m uk-cover-container uk-visible@m">
          <img
            :src="require('@/assets/images/watkostdat.png')"
            alt="Test - Test - 1, 2, 3. Staat dit ding wel aan?"
            class=""
          />
        </div>
      </div>
    </section>
    <!-- End of fourth block -->

    <section class="uk-container-expand uk-background-secondary">
      <div class="uk-container uk-padding-large">
        <h2 class="
            uk-heading-xsmall uk-text-uppercase
            uk-text-secondary no-border uk-text-light"
        >Inhuren als acteur</h2>
        <div class="uk-width-1-3@m uk-margin-auto uk-margin-remove-top">
          <hr class="uk-hr"/>

          <p class="uk-text-secondary uk-text-center">
            Voor acteerwerkzaamheden kun je contact opnemen
            met mijn agent.
          </p>
          <p class="uk-text-secondary uk-text-center">
            Amber de Vente | <a href="http://marbleagency.amsterdam" target="_blank">
            Marble Agency
          </a><br>
            <a href="mailto:amber@marbleagency.amsterdam">
              amber@marbleagency.amsterdam
            </a><br>
            <a href="tel:+31 20 354 1200">+31 20 354 1200</a>.
          </p>
        </div>
      </div>
    </section>

    <contact-form/>
  </div>
</template>

<script>
import VoiceDemoCard from '@/components/VoiceDemoCard.vue';
import USPCardContainer from '@/components/USPCardContainer.vue';
import ImageSectionText from '@/components/ImageSectionText.vue';
import MainHeader from '@/components/MainHeader.vue';
import ContactForm from '@/components/ContactForm.vue';

export default {
  name: 'Main.vue',
  components: {
    VoiceDemoCard,
    USPCardContainer,
    ImageSectionText,
    MainHeader,
    ContactForm,
  },
};
</script>
